// extracted by mini-css-extract-plugin
export default {"customInput":"CustomInputNumber_customInput__JHpDb","fontTypeLarge":"CustomInputNumber_fontTypeLarge__xRZOM","fontTypeSmall":"CustomInputNumber_fontTypeSmall__LZY+S"};